import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import classNames from 'classnames';
import './style.styl';

var Typography = function Typography(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'p' : _ref$as,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body1' : _ref$variant,
      weight = _ref.weight,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "variant", "weight", "className", "children"]);

  var rootClass = classNames('typography', variant, weight, className);
  return /*#__PURE__*/React.createElement(as, Object.assign({
    className: rootClass
  }, props), children);
};

export default Typography;